// extracted by mini-css-extract-plugin
export default {"table-container":"DoublesMatchesList_table-container__LPFfF","matches-table":"DoublesMatchesList_matches-table__C0R9q"};